import { ContentBlock, Typography, Header, Button } from '@/components';
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Flex } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView } from '@/gtag/utils';

export const useStyles = createUseStyles({
  wrapper: {
    height: '100vh',
    backgroundColor: 'rgba(56, 56, 56, 0.8)'
  },
  button: {
    width: 'max-content'
  }
});

export const NotFoundPage = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    trackPageView('/*', 'Not Found Page');
  }, []);

  return (
    <Flex
      className={styles.wrapper}
      justifyContent={'center'}
      alignItems={'center'}
      direction={'column'}
    >
      <Flex justifyContent={'center'} alignItems={'center'}>
        <Typography component="h1">404 |</Typography>
        <Typography component="p">Oops! Page not found.</Typography>
      </Flex>
      <Button
        className={styles.button}
        onClick={() => navigate('/')}
        text={'Go back to Home'}
      />
    </Flex>
  );
};
